import { graphql } from "gql.tada";

const RestaurantLocationFragment = graphql(`
  fragment RestaurantLocationFragment on City {
    __typename
    id
    title
    menuTitle
    slug
    timeZone
  }
`);

export default RestaurantLocationFragment;
